(() => {
  const zeroPlan = '2024599';
  const depositPlan = '2024603';
  const selectedOffer = () => document.querySelector('[data-z-sale-options]')?.dataset.selectedOffer || document.querySelector('[data-z-sale-options] input:checked')?.value || 'economic';
  const unitPrice = (base, offer, discountPercent = 20) => offer === 'regular' ? Math.round(base) : Math.round(base * (1 - discountPercent / 100));
  const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr-CA',{style:'currency',currency:'CAD'}).format(cents / 100);
  const isPaymentKey = key => /_part_payment|_pp_|_flow|_deposit_charge|_cart_flow/.test(key) || ['Part Payment Amount(per product)','Montant du dépôt de confirmation (par produit)','Confirmation deposit amount (per product)'].includes(key);
  const propertiesFor = (original, rate, unitCents, postal = false) => {
    const properties = Object.fromEntries(Object.entries(original || {}).filter(([key]) => !isPaymentKey(key)));
    const requestedOffer = original?._zandomart_offer || selectedOffer();
    const offer = postal || (requestedOffer === 'regular' && rate === 20) ? 'economic' : requestedOffer;
    properties._zandomart_offer = offer;
    properties._zandomart_payment_policy = 'two-offers-v1';
    unitCents = Math.round(unitCents);
    properties._zandomart_unit_price = String(unitCents);
    const discountPercent = Number(original?._zandomart_economic_discount_percent) === 10 ? 10 : 20;
    properties._zandomart_economic_discount_percent = String(discountPercent);
    properties['Offre / Offer'] = offer === 'regular' ? 'Prix régulier — Livraison express / Regular price — Express delivery' : `Prix économique −${discountPercent} % / Economy price −${discountPercent}%`;
    properties._zandomart_deposit_percent = String(postal ? 100 : rate);
    if (postal || rate === 100) {
      properties._zandomart_payment_intent = 'full';
      return properties;
    }
    const amount = (Math.round(unitCents * rate / 100) / 100).toFixed(2);
    Object.assign(properties, {
      _part_payment_id: rate === 0 ? zeroPlan : depositPlan,
      _part_payment_amount: amount,
      _pp_percentage: String(rate),
      _flow: 'part_payment',
      _deposit_charge_flow: 'no_charge',
      _deposit_charge_ratio: '0',
      _cart_flow: 'cart_v2',
      _zandomart_payment_intent: rate === 0 ? 'pay_on_delivery' : 'deposit',
      'Part Payment Amount(per product)': amount
    });
    return properties;
  };
  const productData = () => {
    const node = document.querySelector('[data-z-offer-data]');
    return node ? JSON.parse(node.textContent) : null;
  };
  const resolveVariant = (data, section, form) => {
    const picker = section.querySelector('variant-radios, variant-selects');
    const options = picker?.matches('variant-radios')
      ? [...picker.querySelectorAll('fieldset')].map(field=>field.querySelector('input:checked')?.value)
      : picker ? [...picker.querySelectorAll('select')].map(select=>select.value) : [];
    return (options.length ? data.variants.find(variant=>variant.options.length===options.length && variant.options.every((value,index)=>value===options[index])) : null)
      || data.variants.find(variant=>String(variant.id)===String(form?.querySelector('[name="id"]')?.value))
      || (data.variants.length===1 ? data.variants[0] : null);
  };
  const rateFor = (data, variant, quantity = 1, offer = selectedOffer()) => {
    if (variant.noDeposit) return 0;
    if (data.isWig) return 20;
    if (data.tags.includes('queen')) return 100;
    if (offer === 'economic' && data.tags.includes('bestseller-sans-depot') && (!variant.tracked || variant.stock < quantity)) return 0;
    return offer === 'regular' && data.tags.includes('instock') && variant.tracked && variant.stock >= quantity ? 0 : 20;
  };
  const forVariant = (id, quantity, properties, postal) => {
    const data = productData();
    const variant = data?.variants.find(v => String(v.id) === String(id));
    if (!variant) return properties;
    return propertiesFor({...properties,_zandomart_economic_discount_percent:String(data.discountPercent || 20)},rateFor(data,variant,quantity),properties?._zandomart_offer === 'regular' ? variant.regularPrice : variant.economicPrice,postal);
  };
  const syncProduct = () => {
    const data = productData();
    if (!data) return;
    const section = document.querySelector('[data-z-offer-data]').closest('[id^="ProductInfo-"]');
    const form = section?.querySelector('form[data-type="add-to-cart-form"]');
    const picked = [...(section?.querySelectorAll('variant-radios fieldset') || [])].map(field=>field.querySelector('input:checked')?.value);
    const variant = data.variants.find(v => String(v.id) === form?.querySelector('[name="id"]')?.value) || data.variants.find(v=>picked.length && v.options.every((value,index)=>value===picked[index])) || data.variants[0];
    if (!variant) return;
    const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
    const choices = section.querySelector('[data-z-sale-options]');
    if (!choices) return;
    const colourChoices = [...section.querySelectorAll('[data-z-colour]:checked')];
    const colourIndex = Number(section.querySelector('[data-z-multi-colour]')?.dataset.colourIndex);
    const requested = colourChoices.length ? colourChoices.map(box => ({variant:data.variants.find(v=>v.options.every((o,i)=>o===(i===colourIndex?box.value:variant.options[i]))),quantity:Number(box.closest('[data-z-colour-row]').querySelector('[data-z-colour-quantity]').value)})) : [{variant,quantity}];
    const stockOnly = variant.sourceUrl?.includes('/products/collant-hiver-double-polaire');
    const stocked = requested.filter(x=>x.variant?.tracked && x.variant.stock>0);
    const express = requested.every(x=>x.variant && data.tags.includes('instock') && x.variant.tracked && x.variant.stock>=x.quantity);
    const regular = choices.querySelector('[value="regular"]');
    regular.disabled = !express;
    choices.querySelector('[data-z-express-unavailable]').hidden = express;
    if (!express && selectedOffer()==='regular') choices.dataset.selectedOffer='economic';
    if (!choices.dataset.initialized) {
      choices.dataset.initialized = 'true';
      choices.dataset.selectedOffer = express && new URLSearchParams(location.search).get('offer') === 'regular' ? 'regular' : 'economic';
    }
    if (stockOnly) {
      const regularLabel = regular.closest('.z-sale-choice');
      const economy = choices.querySelector('[value="economic"]');
      regularLabel.hidden = !stocked.length;
      const notice = choices.querySelector('.z-express-start');
      if (notice) notice.hidden = !stocked.length;
      economy.closest('.z-sale-choice').hidden = stocked.length === requested.length;
      regular.disabled = !stocked.length;
      economy.disabled = Boolean(stocked.length);
      choices.dataset.selectedOffer = stocked.length ? 'regular' : 'economic';
    }
    const offer = selectedOffer();
    choices.querySelectorAll('input[name="z_sale_offer"]').forEach(input=>input.checked=input.value===offer);
    const regularPrice = variant.regularPrice;
    const economicPrice = variant.economicPrice;
    const amount = offer === 'regular' ? regularPrice : economicPrice;
    const rate = stockOnly ? 0 : rateFor(data,variant,quantity,offer);
    choices.querySelector('[data-z-regular-price]').textContent = stockOnly ? (document.documentElement.lang.startsWith('fr') ? '1 pour 30 $ · 2 pour 50 $' : '1 for $30 · 2 for $50') : format(regularPrice);
    choices.querySelector('[data-z-economic-compare]').textContent = format(regularPrice);
    choices.querySelector('[data-z-economic-price]').textContent = format(economicPrice);
    choices.querySelector('[data-z-saving]').textContent = format(regularPrice-economicPrice);
    choices.querySelector('.z-sale-saving').hidden = Boolean(stockOnly);
    choices.querySelector('[data-z-economic-compare]').hidden = Boolean(stockOnly);
    choices.querySelector('[data-z-sale-deposit]').hidden = rate!==20;
    choices.querySelector('[data-z-sale-cod]').hidden = rate!==0;
    const deposit = Math.round(amount*rate/100);
    choices.querySelector('[data-z-deposit-value]').textContent = format(deposit);
    choices.querySelector('[data-z-balance-value]').textContent = format(amount-deposit);
    choices.querySelector('[data-z-economic-note]').textContent = rate===0 && offer==='economic' ? data.text.standard_no_deposit : data.tags.includes('queen') && !data.isWig ? data.text.full_note : variant.standardLead===10 ? data.text.colour_deposit_note : data.text.economic_note;
  };

  const checkout = async cart => {
    if (cart.items.some(item => item.properties?._zandomart_offer === 'economic' && item.properties?._zandomart_native_economic !== 'true')) throw new Error('economic-checkout-unavailable');
    const deferred = cart.items.some(item=>item.properties?._part_payment_id);
    if(!deferred){window.location.assign((window.Shopify?.routes?.root || '/')+'checkout');return;}
    const items = cart.items.map(item => {
      if(item.handle !== 'collant-hiver-double-polaire' || item.properties?._zandomart_offer !== 'regular') return item;
      const price = item.final_price;
      const linePrice = item.final_line_price;
      return {...item,price,original_price:price,discounted_price:price,line_price:linePrice,original_line_price:linePrice,properties:{...item.properties,_zandomart_unit_price:String(price)}};
    });
    const response=await fetch('https://depo.sidepanda.com/scripttag/cart_checkout',{
      method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({shopify_domain:window.Shopify.shop,currency:cart.currency,items,note_attributes:Object.entries(cart.attributes || {}).filter(([,value])=>value!==null && value!==undefined && value!=='').map(([name,value])=>({name,value:String(value)}))})
    });
    if(!response.ok)throw new Error('deferred-checkout-'+response.status);
    const result=await response.json();
    const url=new URL(result.invoice_url);
    if(url.protocol!=='https:' || !['zandomart.com','shopify.com','myshopify.com'].some(host=>url.hostname===host || url.hostname.endsWith('.'+host)))throw new Error('checkout-url');
    window.location.assign(url.href);
  };
  window.zandomartPaymentPolicy = {propertiesFor,forVariant,rateFor,syncProduct,checkout,unitPrice};
  window.addEventListener('click', event => {
    const label = event.target.closest?.('.z-sale-choice');
    if (!label) return;
    const input = label.querySelector('input[name="z_sale_offer"]');
    if (!input || input.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    label.closest('[data-z-sale-options]').dataset.userChoice='true';
    label.closest('[data-z-sale-options]').dataset.selectedOffer=input.value;
    setTimeout(() => { input.checked = true; syncProduct(); }, 0);
  }, true);

  window.addEventListener('click',async event => {
    const button = event.target.closest?.('[data-z-offer-add]');
    if (!button || !productData() || button.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const data = productData();
    const section = button.closest('[id^="MainProduct-"]') || button.closest('.shopify-section');
    const form = section.querySelector('form[data-type="add-to-cart-form"]');
    const sizes = section.querySelector('[data-zandomart-two-sizes]');
    const buttons = [...section.querySelectorAll('[data-z-offer-add]')];
    buttons.forEach(control=>{control.disabled=true;control.setAttribute('aria-busy','true');});
    const reset = () => buttons.forEach(control=>{control.disabled=false;control.removeAttribute('aria-busy');});
    const showError = message => { const error=section.querySelector('[data-z-offer-error]'); if(error){if(message)error.textContent=message;error.hidden=false;} };
    try {
      const root=window.Shopify?.routes?.root || '/';
      const cartResponse=await fetch(root+'cart.js',{cache:'no-store'});
      if(!cartResponse.ok) throw new Error('cart');
      const cart=await cartResponse.json();
      const merchandise=cart.items.filter(item=>String(item.variant_id)!=='41999306391685');
      const postal=merchandise.length>0 && merchandise.every(item=>item.properties?._zandomart_delivery_mode==='postal');
    if (!postal && sizes && !sizes.querySelector('[data-zandomart-size]:checked')) {
      sizes.querySelector('input')?.focus();
      const error = section.querySelector('[data-zandomart-delivery-error]');
      if(error) error.style.display='block';
      sizes.scrollIntoView({behavior:'smooth',block:'center'});
      showError(data.text.size_required);
      reset();
      return;
    }
      const current=resolveVariant(data,section,form);
      if(!current) throw new Error('variant');
      const colours=section.querySelector('[data-z-multi-colour]');
      const colourIndex=Number(colours?.dataset.colourIndex);
      const choices=colours ? [...colours.querySelectorAll('[data-z-colour]:checked')] : [];
      const chosen=choices.length ? choices.map(box=>{
        const variant=data.variants.find(v=>v.options.every((option,index)=>option===(index===colourIndex?box.value:current.options[index])));
        return {variant,quantity:Number(box.closest('[data-z-colour-row]').querySelector('[data-z-colour-quantity]').value)};
      }) : [{variant:current,quantity:Number(form.querySelector('[name="quantity"]')?.value || 1)}];
      if(chosen.some(item=>!item.variant || !Number.isInteger(item.quantity) || item.quantity<1)) throw new Error('quantity');
      const trySizes=[...(sizes?.querySelectorAll('[data-zandomart-size]:checked') || [])].map(input=>input.value).join(' + ');
      const items=chosen.map(({variant,quantity})=>{
        const stockOnly = variant.sourceUrl?.includes('/products/collant-hiver-double-polaire');
        const offer = stockOnly ? (variant.tracked && variant.stock > 0 ? 'regular' : 'economic') : postal ? 'economic' : selectedOffer();
        const id = offer === 'regular' ? variant.regularId : variant.economicId;
        const price = offer === 'regular' ? variant.regularPrice : variant.economicPrice;
        if (!id || !Number.isFinite(price)) throw new Error(data.text.checkout_unavailable);
        if(offer==='regular'){
          const alreadyInCart=cart.items.filter(item=>String(item.variant_id)===String(id) && item.properties?._zandomart_offer==='regular').reduce((total,item)=>total+item.quantity,0);
          if(!variant.tracked || alreadyInCart+quantity>variant.stock) throw new Error(data.text.unavailable);
        }
        return {id,quantity,properties:{
          ...propertiesFor({...(!postal?{'Tailles à essayer':trySizes}:{}),_zandomart_economic_discount_percent:String(data.discountPercent || 20),_zandomart_offer:offer,_zandomart_native_economic:String(offer==='economic'),_zandomart_source_variant:String(variant.regularId),_zandomart_source_url:variant.sourceUrl},(stockOnly ? 0 : rateFor(data,variant,quantity,offer)),price,postal),
          _zandomart_delivery_mode:postal?'postal':'local',
          _zandomart_lead_days:String(offer==='regular' && data.tags.includes('instock') && variant.tracked && variant.stock>=quantity?1:variant.standardLead || 6)
        }};
      });
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
      if(!response.ok) {const problem=await response.json().catch(()=>({}));throw new Error(problem.description || problem.message || 'add');}
      window.location.assign(button.dataset.zNext==='home' ? root : root+'cart');
    } catch (error) {
      showError(['variant','cart','quantity','add'].includes(error.message) ? null : error.message);
      reset();
    }
  },true);
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; syncProduct(); });
  };
  document.addEventListener('change',schedule);
  document.addEventListener('DOMContentLoaded',schedule);
  new MutationObserver(records => {
    if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches('input[name="part_payments"],[data-z-offer-data]') || n.querySelector('input[name="part_payments"],[data-z-offer-data]'))))) schedule();
  }).observe(document.documentElement,{childList:true,subtree:true});
  syncProduct();
})();


